import TextSection from "./TextSection";
import HintSection from "./HintSection";
import ImageSection from "./ImageSection";

// The single place a section variant is turned into a component. A new variant
// is one component plus one case here. Unknown variants render nothing rather
// than breaking the page for a typo in the content JSON.
export default function SectionRenderer(props: { section: CaseStudySectionT }) {
  const { section } = props;

  switch (section.variant) {
    case "text":
      return <TextSection section={section} />;
    case "hint":
      return <HintSection section={section} />;
    case "image":
      return <ImageSection section={section} />;
    default:
      return null;
  }
}
